import { api, ApiRes } from '@src/utils/api/client'
import { LanguageOption } from '@src/types'

export interface LanguagesResponse {
    languages: LanguageOption[]
}

export const getLanguages = (): ApiRes<LanguagesResponse> =>
    api.get('v2/languages')
